<template>
	<div class="wrapper">
		<b-row>
			<b-col cols="12">
				<b-card header-tag="header">
					<template v-slot:header>
						<i class="icon-pencil"></i> Membership Management
					</template>
					<b-card-body>
						<b-form>
							<b-form-group
								label="Office"
								label-for="Office"
								:label-cols="3"
								:horizontal="true">
								<multiselect @input="getOfficeMembershipSettings()" v-model="selectedOffice"
														 :options="officeList"
														 :close-on-select="false"
														 :searchable="true"
														 label = "name"
														 placeholder="Pick a value"></multiselect>
							</b-form-group>
							<b-form-group
								v-if="departmentList.length > 0"
								label="Department"
								label-for="Department"
								:label-cols="3"
								:horizontal="true">
								<div class="row">
									<div class="col-6">
										<multiselect v-model="selectedDepartment"
																 :options="departmentList"
																 :close-on-select="false"
																 :searchable="true"
																 label = "name"
																 placeholder="Pick a value"></multiselect>
									</div>
									<div class="col-4">
										<div class="form-actions">
											<b-button type="button" variant="success" @click="updateGeneralSettingsOfOffice()">Save</b-button>
										</div>
									</div>
								</div>
							</b-form-group>
						</b-form>
					</b-card-body>
					<div class="d-flex flex-row mb-5">
						<div class="col-3">
							Generate Dummy Data
						</div>
						<div class="col-6">
							<b-button variant="success" @click="generateMembershipDummyData()"><i
								class="fa-solid fa-engine"></i> Generate Dummy Data
							</b-button>
						</div>
					</div>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import toastService from "@/services/toastService";
	import officeService from "../../services/officeService";
	import Multiselect from 'vue-multiselect'
	import generalSettingsService from "@/services/generalSettingsService";
	import generalSettingsGroupIds from '@/services/generalSettingsGroupIds';
	import departmentService from "../../services/departmentService";
	const MEMBERSHIP_MANAGEMENT_GENERAL_SETTINGS_GROUP_ID = 3;

	export default {
		name: "MembershipManagementGeneralSettings",
		components : {
			Multiselect
		},
		data : function ()  {
			return {
				officeList: [],
				departmentList: [],
				selectedOffice: null,
				selectedDepartment: null,
				availableGeneralSettings:[]
			}
		},
		methods : {
			getOfficeMembershipSettings(){
				if(this.selectedOffice != null){
					departmentService.getAllDepartments(this.selectedOffice.id, (data) => {
						console.log(data);
						this.departmentList = data;
					});
				}
				this.availableGeneralSettings = [];
				if(this.selectedOffice != null){
					generalSettingsService.getGeneralSettings(
						{officeId : this.selectedOffice.id, groupId: generalSettingsGroupIds.MEMBERSHIP_MANAGEMENT_ID}
						, (data) => {
							data.forEach(d=>{
								d.generalSettingsKey.possibleValues = JSON.parse(d.generalSettingsKey.possibleValues);
							});
							this.availableGeneralSettings = data;
							console.log(this.availableGeneralSettings);
						});
				}
			},
			updateGeneralSettingsOfOffice(){
				let data = {};
				data.settings = this.availableGeneralSettings.map( g => {
					return{
						groupId: g.groupId,
						keyId : g.generalSettingsKey.id,
						setValue: this.selectedDepartment.id,
						officeGroupKeyId : g.generalSettingsKey.officeGroupKeyId,
					}
				});
				data.officeId = this.selectedOffice.id;
				data.groupId = MEMBERSHIP_MANAGEMENT_GENERAL_SETTINGS_GROUP_ID;
				generalSettingsService.updateGeneralSettingsOfAnOffice(data, ()=> toastService.showSuccessToast("Updated Successfully"),
					()=> toastService.showErrorToast("Update failed"));
			},

			generateMembershipDummyData(){
				generalSettingsService.generateMembershipDummyData(r =>{
						toastService.showSuccessToast("Data Generation Successful");
					},e =>toastService.showErrorToast(e)
				);
			},
		},
		mounted() {
			officeService.getOfficeList( r => {
				this.officeList = r;
			});
		}
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
